/* eslint-disable @typescript-eslint/no-unsafe-return */
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { AppConfiguration } from '../../shared/model/app-configuration.model';
import { User } from '../../shared/model/user.model';
import { StateStorageService } from '../auth/state-storage.service';
import { ApplicationConfigService } from '../config/application-config.service';
import { SessionStore } from './session.store';

@Injectable({ providedIn: 'root' })
export class SessionService {

  constructor(
    private sessionStore: SessionStore,
    private http: HttpClient,
    private router: Router,
    private stateStorageService: StateStorageService,
    private appConfig: AppConfiguration,
    private applicationConfigService: ApplicationConfigService
  ) {
  }


  login(): Observable<any> {
    
    return this.http.get<User>( this.applicationConfigService.getEndpointFor('api/account')).pipe(
        catchError((err: HttpErrorResponse) => {
          // eslint-disable-next-line no-console
          
          this.stateStorageService.storeUrl(this.normalizeLocalPath(window.location.pathname) ?? '/');
          
          location.href = new URL('oauth2/authorization/gitlab', document.baseURI).toString();
          return throwError(() => err);
        }),
        tap((user: User)  => {
          this.navigateToStoredUrl();
          this.sessionStore.update({user});
        })
    );
  }

  logoutCookie(): void {
    this.http.post<string>(this.applicationConfigService.getEndpointFor('api/logout'), {})
      .subscribe(() => {
        this.sessionStore.update({user: null});
        document.location.reload();
      });
}


  logoutGitlab(): void {
      this.http.post<string>(this.applicationConfigService.getEndpointFor('api/logout'), {})
        .subscribe(() => {
          setTimeout(() => {
            // La logout sembra funzionare uguale, ma poi da errore perché prova a sloggarsi su arpa e non ci riesce,
            // bypassato effettuando la chiamata direttamente da mgp
            const nullBody = new HttpParams().set('_method', 'post');
            this.http.post<string>(this.applicationConfigService.getOscatEndpoint(this.appConfig.oscatUrl, '/users/sign_out'), nullBody).pipe(
              catchError(() =>  of(true))
            )
            .subscribe(() => {
              this.sessionStore.update({user: null});
              location.href = `${this.appConfig.idpLogoutUrl}?redirect_uri=${this.appConfig.redirectAfterLogout}`;
            });
          }, 1)
        });
  }

  private navigateToStoredUrl(): void {
    // previousState can be set in the authExpiredInterceptor and in the userRouteAccessService
    // if login is successful, go to stored previousState and clear previousState
    const previousUrl = this.normalizeLocalPath(this.stateStorageService.getUrl());
    if (previousUrl) {
      this.stateStorageService.clearUrl();
      this.router.navigateByUrl(previousUrl);
    }
  }

  private normalizeLocalPath(path: string | null): string | null {
    if (!path) {
      return path;
    }

    if (!this.isLocalhost()) {
      return path;
    }

    if (path === '/mgp') {
      return '/';
    }

    if (path.startsWith('/mgp/')) {
      const normalized = path.slice('/mgp'.length);
      return normalized.length > 0 ? normalized : '/';
    }

    return path;
  }

  private isLocalhost(): boolean {
    const hostname = window.location.hostname;
    return hostname === 'localhost' || hostname === '127.0.0.1';
  }

}
